class CartOverview extends Component {
	constructor(el) {
		super(el);
		this.summary = this.$find('[data-summary]');
		this.totalVat = this.summary.querySelector('[data-price-vat]');
		this.totalNoVat = this.summary.querySelector('[data-price-no-vat]');
		this.priceFormat = this.$el.dataset.priceFormat;
		this.itemsPriceNoVat = +this.$el.dataset.itemsprice;
		this.itemsPriceVat = +this.$el.dataset.itemspricevat;
		this.currentDeliveryVat = null;
		this.currentDeliveryNoVat = null;
		this.currentPaymentVat = null;
		this.currentPaymentNoVat = null;
		this.addEventListeners();
	}

	updatePrices(vat, noVat) {
		this.totalVat.innerHTML = vat;
		this.totalNoVat.innerHTML = noVat;
	}

	addCurrency(priceText) {
		const numberToReplace = (this.priceFormat.indexOf(',0') !== -1) ? '999,00' : '999';
		return this.priceFormat.replace(numberToReplace, priceText);
	}

	formatPrice(price) {
		const c = (this.priceFormat.indexOf(',0') !== -1) ? 2 : 0;
		let n = price, d = ',', t = ' ', s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = i.length > 3 ? i.length % 3 : 0;
		const priceText = s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
		return this.addCurrency(priceText);
	}

	recalculateCart() {
		const vat = this.currentDeliveryVat + this.currentPaymentVat + this.itemsPriceVat;
		const noVat = this.currentDeliveryNoVat + this.currentPaymentNoVat + this.itemsPriceNoVat;

		this.updatePrices(this.formatPrice(vat), this.formatPrice(noVat));
	}

	setCurrentDelivery({priceVat, priceNoVat}) {
		this.currentDeliveryVat = +priceVat;
		this.currentDeliveryNoVat = +priceNoVat;
		this.recalculateCart();
	}

	setCurrentPayment({priceVat, priceNoVat}) {
		this.currentPaymentVat = +priceVat;
		this.currentPaymentNoVat = +priceNoVat;
		this.recalculateCart();
	}

	addEventListeners() {
		EventBus.getInstance().addEventListener('cartDeliveryChanged', e => this.setCurrentDelivery(e.detail));
		EventBus.getInstance().addEventListener('cartPaymentChanged', e => this.setCurrentPayment(e.detail));
	}
}